<header>
  <h2 color="warn">Error : {{ data.code }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</header>
<mat-dialog-content class="mat-typography">
  <div>
    {{ data.title }}
  </div>
  <div class="details" *ngIf="details">
    <h3>Error Details</h3>
    <pre>
      <p [class.wrap]="data.code !== '45'">{{ detailsData | json }}</p>
    </pre>
    <h3>Trace ID</h3>
    <pre>
      <p>{{ data.trace_id! }}</p>
    </pre>
    <div class="details-actions">
      <div class="details-actions">
        <span *ngIf="copySucceed">Details successfully copied !</span>
        <button
          mat-icon-button
          (cdkCopyToClipboardCopied)="copied($event)"
          [cdkCopyToClipboard]="(detailsData | json) + '\n' + data.trace_id!"
        >
          <mat-icon>content_copy</mat-icon>
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-flat-button color="warn" (click)="showDetails()">
    {{ details ? "Hide Details" : "Show Details" }}
  </button>
</mat-dialog-actions>
<div class="autoclose" *ngIf="!details">
  <div class="autoclose-bar"></div>
</div>
